import { DnDContext } from './getDnDContext';
import { updateDropTarget } from './updateDropTarget';

export const layoutDropTargets = (dndContext: NonNullable<DnDContext>) => {
  const { dropTargets, availableWidth, columnCount, rowCount, deltaX, deltaY } =
    dndContext;
  const layoutContex = {
    x: 0,
    y: 0,
    height: 0,
    width: 0,
  };
  dropTargets.forEach(dropTarget => {
    let currentX = layoutContex.x;
    let currentY = layoutContex.y;

    if (columnCount === 1) {
      layoutContex.x = 0;
      layoutContex.y += dropTarget.box.height + deltaY;
    } else if (rowCount === 1) {
      layoutContex.y = 0;
      layoutContex.x += dropTarget.box.width + deltaX;
    } else if (layoutContex.x + dropTarget.box.width <= availableWidth) {
      layoutContex.x += dropTarget.box.width + deltaX;
      if (dropTarget.box.height > layoutContex.height) {
        layoutContex.height = dropTarget.box.height;
      }
    } else {
      // Wrap to next row.
      currentY = layoutContex.y + layoutContex.height + deltaY;
      currentX = 0;
      layoutContex.y = currentY;
      layoutContex.x = dropTarget.box.width + deltaX;
      layoutContex.height = dropTarget.box.height;
    }
    updateDropTarget(dropTarget, currentX, currentY);
  });
};
